export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-2.9f3c0762.png";